<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.combining",
                    :checked='params.combining',
                    @change='combiningHandler',
                    :disabled='combiningDisabled'
                )
        .settings__field(v-if="params.combining && !params.roundNumbers && !params.fractions")
            .settings__field-body
                combining-digit-capacity(
                    inner-component-name="settings-tab",
                    :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                    :combining-digit-capacities='params.combiningDigitCapacities',
                    :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                    @changeCombiningDigitCapacities='changeCombiningDigitCapacities'
                )
        template(v-if="slug !== 'AdditionAndSubtractionMathMagic'")
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_simple') }}
                .settings__field-body
                    settings-tab.settings__button(
                        v-for="number in 9",
                        :key="number",
                        :selected="params && params.simple && params.simple.includes(number)",
                        @click.native.prevent="setNumber(number, 'simple')",
                        :disabled="isSimpleDisabled(number)"
                    ) {{ number }}
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_brothers') }}
                .settings__field-body
                    settings-tab.settings__button(
                        v-for="number in Array.from(Array(4), (_, i) => i + 1).reverse()",
                        :key="number",
                        :selected="params && params.brothers && params.brothers.includes(number)",
                        @click.native.prevent="setNumber(number, 'brothers')"
                        ::disabled="brothersDisabled"
                    )
                        | {{ number }}
                    settings-tab.settings__button.settings__space-between-elements(
                        :disabled="areBrothersOnlyOptionsDisabled",
                        :selected="params && params.brothersOptions && params.brothersOptions.onlyAddition",
                        @click.native.prevent="params.brothersOptions.onlyAddition = !params.brothersOptions.onlyAddition"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                    settings-tab.settings__button(
                        :disabled="areBrothersOnlyOptionsDisabled",
                        :selected="params && params.brothersOptions.onlySubtraction",
                        @click.native.prevent="params.brothersOptions.onlySubtraction = !params.brothersOptions.onlySubtraction"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_friends') }}
                .settings__field-body
                    settings-tab.settings__button(
                        v-for="(number, index) in Array.from(Array(9), (_, i) => i + 1).reverse()",
                        :key="number",
                        :selected="params && params.friends && params.friends.includes(number)",
                        @click.native.prevent="setNumber(number, 'friends')",
                        :disabled="isOnlyJumpOverSetting(number, 'friends') || friendsDisabled"
                    )
                        | {{ number }}
            .settings__field
                settings-tab.settings__button(
                    :disabled="areFriendsOnlyOptionsDisabled",
                    :selected="params && params.friendsOptions.onlyAddition",
                    @click.native.prevent="params.friendsOptions.onlyAddition = !params.friendsOptions.onlyAddition"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                settings-tab.settings__button(
                    :disabled="areFriendsOnlyOptionsDisabled",
                    :selected="params && params.friendsOptions.onlySubtraction",
                    @click.native.prevent="params.friendsOptions.onlySubtraction = !params.friendsOptions.onlySubtraction"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends') }}
                .settings__field-body
                    settings-tab.settings__button(
                        v-for="(number, index) in Array.from(Array(9), (_, i) => i + 1).slice(5)",
                        :key="number",
                        :selected="params && params.brothersAndFriends && params.brothersAndFriends.includes(number)",
                        @click.native.prevent="setNumber(number, 'brothersAndFriends')",
                        :disabled="isOnlyJumpOverSetting(number, 'brothersAndFriends') || brothersAndFriendsDisabled"
                    )
                        | {{ number }}
                    settings-tab.settings__button.settings__space-between-elements(
                        :disabled="areBrothersAndFriendsOnlyOptionsDisabled",
                        :selected="params && params.brothersAndFriendsOptions.onlyAddition",
                        @click.native.prevent="params.brothersAndFriendsOptions.onlyAddition = !params.brothersAndFriendsOptions.onlyAddition"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                    settings-tab.settings__button(
                        :disabled="areBrothersAndFriendsOnlyOptionsDisabled",
                        :selected="params && params.brothersAndFriendsOptions.onlySubtraction",
                        @click.native.prevent="params.brothersAndFriendsOptions.onlySubtraction = !params.brothersAndFriendsOptions.onlySubtraction"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_transitionThrough') }}
                .settings__field-body
                    cs-multiselect.settings__multiselect(
                        :options='jumpOver',
                        :show-labels='false',
                        :allow-empty='true',
                        track-by='value',
                        label='value',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                        :disabled='!isAllowJumpOver',
                        v-model='params.jumpOver'
                    )
            .settings__field
                label.settings__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
                .settings__field-body
                    cs-spin-input(
                        v-if="slug === 'AdditionAndSubtractionWithTime'"
                        width="xxx-large",
                        type="text",
                        :value="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${params.speed}с`",
                        :max="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${seconds[seconds.length - 1]}с`",
                        :min="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${seconds[0]}с`",
                        @increase="increaseSpeed",
                        @decrease="decreaseSpeed",
                    )
                    cs-spin-input.settings__space-between-elements(
                        width="xxx-large"
                        type="text",
                        :value="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${params.amountOfActions}`",
                        :max="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${amountsOfActions[amountsOfActions.length - 1]}`",
                        :min="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${amountsOfActions[0]}`",
                        @increase="increaseAmountOfActions",
                        @decrease="decreaseAmountOfActions",
                    )
            .settings__field
                .settings__field-body
                    settings-tab.settings__button(
                        @click.native.prevent='params.mirror = !params.mirror',
                        :selected="params.mirror",
                        :disabled="(params.difficult === 'Однозначные цифры' || params.fractions || params.roundNumbers)"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
                    settings-tab.settings__button(
                        @click.native.prevent='roundNumbersHandler',
                        :selected="params.roundNumbers",
                        :disabled="(params.difficult === 'Однозначные цифры' || params.fractions || params.mirror)"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
</template>

<script>
    /*eslint-disable*/
    import combiningCapacitiesMixin from '../../games/utils/combiningCapacitiesMixin';
    import CombiningDigitCapacity from '../../games/shared/CombiningDigitCapacity.vue';
    import AddSubConfig from "../configs/AddSubConfig";

    const SIMPLE = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    const BROTHERS = [4, 3, 2, 1];
    const FRIENDS = [9, 8, 7, 6, 5, 4, 3, 2, 1];
    const BROTHERS_AND_FRIENDS = [6, 7, 8, 9];
    const SIMPLE_KEY = 'simple';
    const BROTHERS_KEY = 'brothers';
    const FRIENDS_KEY = 'friends';
    const BROTHERS_AND_FRIENDS_KEY = 'brothersAndFriends';
    const FORMULAS_KEYS = [SIMPLE_KEY, BROTHERS_KEY, FRIENDS_KEY, BROTHERS_AND_FRIENDS_KEY];
    const EXAMPLES_TYPE_KEYS = ['friendsOptions', 'brothersOptions', 'brothersAndFriendsOptions'];
    const ADDITION = 'addition';
    const SUBTRACTION = 'subtraction';
    const ADDITION_AND_SUBTRACTION = 'additionAndSubtraction';

    export default {
        mixins: [combiningCapacitiesMixin],
        props: {
            currentUserParams: {
                type: Object,
                default () {
                    return null;
                }
            },
            slug: {
                type: String,
                default: 'AdditionAndSubtraction'
            }
        },
        data () {
            return {
                params: null,
                jumpOver: [
                    {
                        value: 50
                    },
                    {
                        value: 100
                    }
                ],
                seconds: AddSubConfig.seconds,
                currentSpeedIndex: 0,
                amountsOfActions: [...Array(101).keys()].slice(2),
            }
        },
        watch: {
            currentUserParams: {
                handler (value) {
                    this.params = value;
                    this.currentSpeedIndex = this.seconds.indexOf(this.params.speed);
                }
            },
            'params.friendsOptions.onlyAddition' (val) {
                if (val) {
                    this.params.friendsOptions.onlySubtraction = false;
                }
            },
            'params.friendsOptions.onlySubtraction' (val) {
                if (val) {
                    this.params.friendsOptions.onlyAddition = false;
                }
            },
            'params.brothersOptions.onlyAddition' (val) {
                if (val) {
                    this.params.brothersOptions.onlySubtraction = false;
                }
            },
            'params.brothersOptions.onlySubtraction' (val) {
                if (val) {
                    this.params.brothersOptions.onlyAddition = false;
                }
            },
            'params.brothersAndFriendsOptions.onlyAddition' (val) {
                if (val) {
                    this.params.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            'params.brothersAndFriendsOptions.onlySubtraction' (val) {
                if (val) {
                    this.params.brothersAndFriendsOptions.onlyAddition = false;
                }
            },
            areBrothersOnlyOptionsDisabled (val) {
                if (val && this.params.brothersOptions) {
                    this.params.brothersOptions.onlyAddition = false;
                    this.params.brothersOptions.onlySubtraction = false;
                }
            },
            areFriendsOnlyOptionsDisabled (val) {
                if (val && this.params.friendsOptions) {
                    this.params.friendsOptions.onlyAddition = false;
                    this.params.friendsOptions.onlySubtraction = false;
                }
            },
            areBrothersAndFriendsOnlyOptionsDisabled (val) {
                if (val && this.params.brothersAndFriendsOptions) {
                    this.params.brothersAndFriendsOptions.onlyAddition = false;
                    this.params.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            'params.mirror' (val) {
                if (val) {
                    this.params.jumpOver = null;
                }
            },
        },
        methods: {
            increaseSpeed () {
                this.currentSpeedIndex += 1;
                this.params.speed = this.seconds[this.currentSpeedIndex];
            },
            decreaseSpeed () {
                this.currentSpeedIndex -= 1;
                this.params.speed = this.seconds[this.currentSpeedIndex];
            },
            increaseAmountOfActions () {
                this.params.amountOfActions += 1;
            },
            decreaseAmountOfActions () {
                this.params.amountOfActions -= 1;
            },
            setNumber(number, type) {
                if (type !== SIMPLE_KEY) {
                    this.params.simple = SIMPLE;
                }
                if (!!this.params[type] && this.params[type].includes(number)) {
                    this.params[type] = this.params[type].filter(value => value !== number);
                } else {
                    !this.params[type] && (this.params[type] = []);
                    this.params[type].push(number);
                }
            },
            roundNumbersHandler () {
                this.params.roundNumbers = !this.params.roundNumbers;
                if (this.params.roundNumbers) {
                    this.params.jumpOver = null;
                }
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            combiningHandler (combining) {
                this.params.combining = combining;
                if (combining) {
                    this.params.jumpOver = null;
                }
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            isSimpleDisabled (number) {
                return this.simpleDisabled
                        || this.params && this.params.simple && (
                                this.params.simple.filter(value => value <= 2).length === 1
                                && number <= 2
                                && this.params.simple.includes(number)
                        );
            },
            isOnlyJumpOverSetting (number, type) {
                const oppositeType = type === FRIENDS_KEY ? BROTHERS_AND_FRIENDS_KEY : FRIENDS_KEY;
                return this.params && (!!this.params.jumpOver
                        && this.params[type].includes(number)
                        && this.params[type].length === 1
                        && !this.params[oppositeType].length);
            }
        },
        computed: {
            simpleDisabled () {
                return this.params && (!!this.params.brothers?.length
                        || !!this.params.friends?.length
                        || !!this.params.brothersAndFriends?.length
                        || this.params.negativeAnswers
                        || this.params.interimAnswers);
            },
            brothersDisabled() {
                return this.params && (this.params.negativeAnswers
                        || !!this.params.interimAnswers
                        || !!this.params.jumpOver);
            },
            friendsDisabled() {
                return this.params && !!this.params.interimAnswers;
            },
            brothersAndFriendsDisabled() {
                return this.params && !!this.params.interimAnswers;
            },
            isAllowJumpOver() {
                return this.params && !this.params.combining
                        && (
                                (this.params.friends && this.params.friends.length > 0)
                                ||
                                (this.params.brothersAndFriends && this.params.brothersAndFriends.length > 0)
                        )
                        && (this.params.difficult !== 'Однозначные цифры' || !this.params.negativeAnswers)
                        && !this.params.fractions
                        && !this.params.roundNumbers
                        && !this.params.mirror
            },
            areBrothersOnlyOptionsDisabled () {
                return this.params && (!!this.params.interimAnswers || !this.params.brothers?.length);
            },
            areFriendsOnlyOptionsDisabled () {
                return this.params
                        && (
                                this.params.interimAnswers
                                || (
                                        this.params.negativeAnswers
                                        && (!this.params.brothersAndFriends?.length || this.params.brothersAndFriendsOptions?.onlyAddition)
                                ) || !this.params.friends?.length);
            },
            areBrothersAndFriendsOnlyOptionsDisabled () {
                return this.params
                        && (
                                this.params.interimAnswers
                                || (
                                        this.params.negativeAnswers
                                        && (!this.params.friends?.length || this.params.friendsOptions?.onlyAddition)
                                ) || !this.params.brothersAndFriends?.length);
            },
            combiningDisabled () {
                return this.params &&
                    (
                        (this.params.difficult === 'Однозначные цифры' || this.params.mirror)
                        ||
                        (this.params.difficult === 'Двузначные цифры' && this.params.roundNumbers)
                    );
            },
        },
        components: {
            CombiningDigitCapacity,
        }
    }
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 40px 15px;
        @include media($xl) {
            padding: 25px 40px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: flex-start;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__space-between-elements {
        margin-left: 10px;
    }
    .settings__multiselect {
        width: 160px !important;
    }
</style>
